export const features = {
  POINTS: 'points',
  POPULATION_STRUCTURE: 'population-structure',
  AREA_DEVELOPMENT: 'area-development',
  PROPERTY_MARKET: 'property-market',
  RESIDENTIAL_MARKET: 'residential-market',
  HOUSEHOLDS: 'households',
  SERVICES: 'services',
  FOOTFALL: 'footfall',
  TENANT_SEARCH: 'tenant-search',
  LOI_CSV_UPLOAD: 'loi-csv-upload',
  RETAIL_MARKET_ANALYSIS: 'retail-market-analysis',
  RETAIL_CATCHMENT_ANALYSIS: 'retail-catchment-analysis',
  REAMS: 'reams',
  MML_REAL_ESTATE_PDFS: 'mml-real-estate-pdfs',
  CHAOS_AI: 'chaos-ai',
  AI_REPORTS: 'ai-reports',
  ASKING_PRICE_ESTIMATION: 'asking-price-estimation',
  BUILDING_GROUP: 'building-group',
};
